import React from "react";
import { AppUI } from "./AppUI";
import { TodoProvider } from "../TodoContext";


/* const defaultTodos = [
  {text: "Cortar cebolla", completed: true},
  {text: "Curso de Intro a React", completed: false},
  {text: "Alimentar perrito", completed: false},
]
 */

function App() {



  return (

      <TodoProvider>
        <AppUI/>
      </TodoProvider>

  );
}

export default App;
